import { List } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { isGUID } from '@client/shared/utils/utils/utils';
import { FUNDRAISER_REDUCER_KEY } from '@client/redux/fundraiser/fundraiserReducer';
import { getDefaultDescriptionText } from '@client/shared/utils/fundraiserUtils/fundraiserUtils';

export const selectFundraiser = (state) => {
  return getIn(state[FUNDRAISER_REDUCER_KEY], 'fundraiser');
};

export const selectFundraisers = (state) => {
  return (
    getIn(state[FUNDRAISER_REDUCER_KEY], 'fundraiser', 'results') || List()
  );
};

// Needed because we first used a GUID in the url and we dont want to break those links
export const selectFundraiserByIdOrSlug = (state, idOrSlug) => {
  return isGUID(idOrSlug)
    ? selectFundraiserById(state, idOrSlug)
    : selectFundraiserBySlug(state, idOrSlug);
};

export const selectFundraiserById = (state, id) => {
  const fundraisers = selectFundraisers(state);

  return (
    fundraisers &&
    fundraisers.find((fundraiser) => {
      return getIn(fundraiser, 'id') === id;
    })
  );
};

export const selectFundraiserByType = (state, type) => {
  const fundraisers = selectFundraisers(state);

  return (
    fundraisers &&
    fundraisers.filter((fundraiser) => {
      return getIn(fundraiser, 'fundraiserType') === type;
    })
  );
};

export const selectFundraiserBySlug = (state, slug) => {
  const fundraisers = selectFundraisers(state);

  return (
    fundraisers &&
    fundraisers.find((fundraiser) => {
      return getIn(fundraiser, 'slug') === slug;
    })
  );
};

export const selectFundraisersByEventName = (state, eventName) => {
  const fundraisers = selectFundraisers(state);

  return (
    fundraisers &&
    fundraisers.find((fundraiser) => {
      return getIn(fundraiser, 'eventName') === eventName;
    })
  );
};

export const selectFundraiserIdBySlug = (state, slug) => {
  const fundraisers = selectFundraisers(state);
  const fundraiser =
    fundraisers &&
    fundraisers.find((fundraiser) => {
      return getIn(fundraiser, 'slug') === slug;
    });

  return fundraiser && getIn(fundraiser, 'id');
};

export const selectFundraiserComment = (state) => {
  return getIn(state[FUNDRAISER_REDUCER_KEY], 'fundraiserComment');
};

export const selectFundraiserTypes = (state) => {
  return getIn(state[FUNDRAISER_REDUCER_KEY], 'fundraiserTypes');
};

export const selectFundraiserTypeByID = (state, id) => {
  const types = selectFundraiserTypes(state);
  return (
    types &&
    types.find((type) => {
      return getIn(type, 'id') === id;
    })
  );
};

export const selectFundraiserStatus = (state) => {
  return getIn(state[FUNDRAISER_REDUCER_KEY], 'status');
};

export const selectDefaultDescriptionText = (state, fundraiserType) => {
  return getDefaultDescriptionText(
    selectFundraiserTypes(state),
    fundraiserType
  );
};
